export default function Logo(): React.ReactElement {
  return (
    <svg width="240" height="28" viewBox="0 0 240 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Anthropic</title>
      <g clipPath="url(#clip0_444_1266)">
        <path
          d="M48.8789 19.4148L37.1463 0.460938H30.8032V27.5132H36.1928V8.5594L47.9254 27.5132H54.2684V0.460938H48.8789V19.4148Z"
          fill="#181818"
        />
        <path d="M58.7334 5.67324H67.481V27.5132H73.0778V5.67324H81.8255V0.460938H58.7334V5.67324Z" fill="#181818" />
        <path
          d="M104.155 11.2732H91.8834V0.504014H86.2866V27.5563H91.8834V16.4856H104.155V27.5563H109.752V0.460938H104.155V11.2732Z"
          fill="#181818"
        />
        <path
          d="M122.193 5.67314H129.075C131.811 5.67314 133.262 6.70698 133.262 8.68852C133.262 10.6701 131.811 11.7039 129.075 11.7039H122.193V5.67314ZM138.859 8.7316C138.859 3.60545 135.252 0.503906 129.324 0.503906H116.596V27.5562H122.193V16.9593H128.412L134.009 27.5562H140.186L134.009 16.1408C137.118 14.8916 138.859 12.307 138.859 8.7316Z"
          fill="#181818"
        />
        <path
          d="M155.96 22.5723C151.566 22.5723 148.871 19.3415 148.871 14.0431C148.871 8.65846 151.566 5.42769 155.96 5.42769C160.313 5.42769 162.967 8.65846 162.967 14.0431C162.967 19.3415 160.313 22.5723 155.96 22.5723ZM155.96 0C148.456 0 143.108 5.81538 143.108 14.0431C143.108 22.1846 148.415 28 155.96 28C163.423 28 168.729 22.1846 168.729 14.0431C168.729 5.81538 163.464 0 155.96 0Z"
          fill="#181818"
        />
        <path
          d="M186.432 12.4794H179.55V5.67324H186.432C189.168 5.67324 190.619 6.83632 190.619 9.07632C190.619 11.3163 189.21 12.4794 186.432 12.4794ZM186.681 0.460938H173.953V27.5132H179.55V17.7348H186.681C192.609 17.7348 196.216 14.504 196.216 9.1194C196.216 3.73478 192.609 0.460938 186.681 0.460938Z"
          fill="#181818"
        />
        <path
          d="M234.046 18.4369C233.093 21.0646 231.144 22.5723 228.491 22.5723C224.097 22.5723 221.402 19.3415 221.402 14.0431C221.402 8.65846 224.097 5.42769 228.491 5.42769C231.144 5.42769 233.051 6.93539 234.046 9.56308H239.975C238.482 3.74769 234.129 0 228.491 0C220.987 0 215.639 5.81538 215.639 14.0431C215.639 22.1846 220.946 28 228.491 28C234.171 28 238.524 24.2092 239.975 18.4369H234.046Z"
          fill="#181818"
        />
        <path d="M198.472 0.460938L208.878 27.5132H214.557L204.151 0.460938H198.472Z" fill="#181818" />
        <path
          d="M9.82553 16.8302L13.3909 7.31017L16.9563 16.8302H9.82553ZM10.4059 0.460938L0 27.5563H5.80411L7.91847 21.8702H18.7804L20.8948 27.5563H26.6989L16.3344 0.460938H10.4059Z"
          fill="#181818"
        />
      </g>
      <defs>
        <clipPath id="clip0_444_1266">
          <rect width="240" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
